import React, { Component } from "react";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSignOutAlt} from "@fortawesome/free-solid-svg-icons";
import {connect} from "react-redux";
import {logoutUser} from "../../actions/authActions";
import {Link} from "react-router-dom";
import socketIOClient from "socket.io-client";
import * as myConstList from '../../BaseUrl';
const source = localStorage.getItem("source");
const theme = localStorage.getItem("theme");
const baseUrl = myConstList.baseUrl;
const jwtToken = localStorage.getItem("jwtToken");
class Sidebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            thirdPhaseConfig:"",           
        };
    }
    onLogoutClick = e => {
        e.preventDefault();
        this.props.logoutUser();
    };

    componentDidMount() {
        const socket = socketIOClient(baseUrl, {query:"jwtToken=" +jwtToken});
        var collectThis = this;
        socket.on("connect", () => {
            collectThis.setState({ currentSocketId: socket.id });
            socket.emit("config3rdphase");            
        });
        socket.on("3rdPhaseConfig", function (apiRespData) {
            if (socket.id == collectThis.state.currentSocketId) {
                var arr = [];
                arr['account']= apiRespData.data[0].account;
                arr['transaction']= apiRespData.data[0].transaction;
                collectThis.setState({ thirdPhaseConfig: arr });
            }
        });
    };
    
    render() {
        var url = "?source="+localStorage.getItem("source")+"&theme="+localStorage.getItem("theme");
        //const { user } = this.props.auth;
        return (
            <>
                   {/* <button className="navbar-toggler nav_btn collapsed" type="button" data-toggle="collapse" data-target="#navbarText">
            <span className="icon-bar"><i className="las la-times"></i></span>
        </button> */}
        <div className="nav_content collapse navbar-collapse" id="navbarText">
         <ul className="navbar-nav  line">
               <li className="nav-item">
                <a href={(source!=='' && theme !=="")?"/dashboard"+url:"/dashboard"} className="nav-link"><i className="las la-tachometer-alt"></i>Dashboard</a>
                    
                </li>
                {/* <li className="nav-item">
                <a href={(source!=='' && theme !=="")?"/contest"+url:"/contest"} className="nav-link"><i className="las la-trophy"></i>Contest</a>
                    
                </li> */}
                {/* <li className="nav-item">
                <a href="/profile-user" className="nav-link"><i className="las la-user"></i>Profile</a>
                
                </li> */}
                {/* <li className="nav-item">
                <a href={(source!=='' && theme !=="")?"/winningHistoryTable"+url:"/winningHistoryTable"} className="nav-link"><i className="las la-wallet"></i>Winning Contest</a>
                   
                </li> */}
                {/* {this.state.thirdPhaseConfig.account ==='1' && */}
                <li className="nav-item">
                <a href={(source!=='' && theme !=="")?"/account"+url:"/account"} className="nav-link" onClick={() => this.tabClick('Account')}><i className="las la-user"></i>Points Wallet</a>                   
                </li>
                {/* } */}
                <li className="nav-item">
                <a href={(source!=='' && theme !=="")?"/addCash"+url:"/addCash"} className="nav-link" onClick={() => this.tabClick('addCash')}><i className="las la-dollar-sign"></i>Cash Wallet</a> 
                </li>
                {/* {this.state.thirdPhaseConfig.transaction ==='1' && */}
                <li className="nav-item">
                <a href={(source!=='' && theme !=="")?"/transaction-history"+url:"/transaction-history"} className="nav-link" onClick={() => this.tabClick('transaction-history')}><i className="las la-history"></i>Transaction History</a>
                </li>
                {/* } */}
                <li className="nav-item">
                <a href={(source!=='' && theme !=="")?"/withdrawal"+url:"/withdrawal"} className="nav-link" onClick={() => this.tabClick('withdrawal')}><i className="las la-history"></i>Withdrawal</a>
                </li>
				{/* <li className="nav-item">
                <a href="/help-center" className="nav-link"><i className="las la-headset"></i><i className="las la-history"></i>Submit Ticket</a>
                   
                </li> */}
                {/* <li className="nav-item">
                <a href="/help-history" className="nav-link"><i className="las la-history"></i><i className="las la-ticket-alt"></i>Ticket History</a>
                   
                </li> */}
                {/* <li className="nav-item">
                    <a className="nav-link " href="#" onClick={this.onLogoutClick}><i className="las la-sign-out-alt"></i>Logout</a> 
                </li> */}
            </ul>
          
        </div>
          </> 
        );
    }
}

Sidebar.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(
    mapStateToProps,
    { logoutUser }
)(Sidebar);
